import { useState, useEffect, useCallback } from 'react';

const VERSION_CHECK_INTERVAL = 1800000; // 30 dakikada bir kontrol et (ms)

// Mevcut sayfadaki build-time meta tag'ini oku
function getCurrentBuildTimeFromMeta() {
  const meta = document.querySelector('meta[name="build-time"]');
  return meta ? meta.getAttribute('content') : null;
}

// Fetch edilen HTML'den build-time meta tag değerini parse et
function parseBuildTimeFromHtml(html) {
  const match = html.match(/<meta name="build-time" content="(\d+)"/);
  return match ? match[1] : null;
}

export function useVersionCheck() {
  const [hasNewVersion, setHasNewVersion] = useState(false);

  const checkVersion = useCallback(async () => {
    try {
      const currentBuildTime = getCurrentBuildTimeFromMeta();
      if (!currentBuildTime) return;

      // index.html'i cache bypass ile fetch et
      const response = await fetch(`/index.html?t=${Date.now()}`, {
        cache: 'no-store',
      });
      if (!response.ok) return;

      const html = await response.text();
      const serverBuildTime = parseBuildTimeFromHtml(html);

      if (serverBuildTime && serverBuildTime !== currentBuildTime) {
        setHasNewVersion(true);
      }
    } catch (error) {
      console.warn('Version check failed:', error);
    }
  }, []);

  useEffect(() => {
    // İlk kontrol (5 saniye gecikmeyle - sayfa yüklensin)
    const initialTimeout = setTimeout(checkVersion, 5000);

    // Periyodik kontrol
    const intervalId = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, [checkVersion]);

  const dismissUpdate = useCallback(() => {
    setHasNewVersion(false);
  }, []);

  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return {
    hasNewVersion,
    dismissUpdate,
    refreshPage
  };
}
